import {animate, state, style, transition, trigger} from "@angular/animations";

const animationDuration = '300ms';

export const showOpacityAnimation =
  trigger('showOpacity', [
    state('*', style({
      opacity: 0,
    })),
    state('show', style({
      opacity: 1,
    })),
    state('hide', style({
      opacity: 0,
    })),
    transition('* => show', animate(animationDuration + ' ease-in-out')),
    transition('* => hide', animate(animationDuration + ' ease-in-out'))
  ]);

export const enterLeaveOpacityAnimation = trigger('enterLeaveOpacity', [
  transition(':enter', [style({opacity: 0}), animate('150ms', style({opacity: 1}))]),
  transition(':leave', [style({opacity: 1}), animate('150ms', style({opacity: 0}))])
]);

export const enterOpacityAnimation = trigger('enterOpacity', [
  transition(':enter', [style({opacity: 0}), animate('150ms', style({opacity: 1}))])
]);

export const enterLeaveTableOpacityAnimation = trigger('enterLeaveTableOpacity', [
  transition(':enter', [style({opacity: 0}), animate('250ms 250ms', style({opacity: 1}))])
]);
